import { environmentDataAttribute } from './script-attributes'

export enum ScriptDataAttributes {
	required = 'data-auth-required',
	successTarget = 'data-auth-success-target',
	failTarget = 'data-auth-fail-target',
	appClientID = 'data-auth-client-id',
	waypointTarget = 'data-auth-waypoint-target',
	missingInfo = 'data-missinginfo-required',
	logoutURL = 'data-post-logout-target',
	sessionStorageKeyPrefix = 'data-session-storage-clear-prefix',
	baseApiUrlOverride = 'data-base-api-url-override',
	channelOverride = 'data-auth-channel-override',
	brandOverride = 'data-auth-login-brand-override',
	localeOverride = 'data-auth-locale-override',
	loginHint = 'data-auth-login-hint',
	mockEnabled = 'data-mock-enabled',
	policy = 'data-auth-policy',
	tenant = 'data-auth-tenant',
	disclosureCloseButtonLabel = 'data-disclosure-close-button-label',
	useDataAttributes = 'data-use-data-attributes',
	languageDataAttribute = 'data-language',
	countryDataAttribute = 'data-country',
	environmentDataAttribute = 'data-environment',
	rtlDataAttribute = 'data-rtl',
	/** `b2c` (default) or `entra-external-id` for North America parallel IAM. */
	identityProvider = 'data-auth-identity-provider',
}
